import { Injectable } from '@angular/core';
import type { MapboxMap } from '@polaris-customerweb/sharedcomponents.core';
import { ConsoleLogService } from '@polaris-customerweb/sharedcomponents.shared';
import { ContactMessageVm } from '../state/check-in-contacts/contact-message.vm';
import { MapContentMapService } from './map-content-map.service';
import { MapService } from './map.service';

@Injectable({ providedIn: 'root' })
export class CheckInContactMessageMapService extends MapContentMapService {
    minZoom = 8;

    constructor(consoleLogService: ConsoleLogService, mapService: MapService) {
        super(consoleLogService, mapService);
        super.setSourceId('groupridecheckin');
    }

    setSourceDataFromModel(
        mapboxMap: MapboxMap,
        contactMessage: ContactMessageVm
    ) {
        super.setSourceData(mapboxMap, contactMessage?.toGeoJson());
    }
}
